import React from 'react'
import Template from '../components/Template.js'
import Layout from '../components/Layout.js'
export default function Templates() {
    return (
        <Layout>
            <Template />
        </Layout>
    )
}
